import { Permissions } from './Permissions.Query';

export default Permissions;